// extracted by mini-css-extract-plugin
export default {"main":"AssetDetailLine_main__vDb1Y","heading":"AssetDetailLine_heading__Halnc"};